import {
    GET_CART_UPDATED_STATUS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CART_UPDATED_STATUS:
            return {
                ...state,
                SUBMIT_loading: false,
                cartUpdatedStatus: action.cartUpdatedStatus,
            }
        default:
            return state
    }
}